import { Component, OnInit } from '@angular/core';
import { BookstoreService } from 'src/app/services/bookstore/bookstore.service';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';

@Component({
  selector: 'app-stock-information',
  templateUrl: './stock-information.component.html',
  styleUrls: ['./stock-information.component.css']
})
export class StockInformationComponent implements OnInit {

  StockInformationList:any=[];
  ItemCategoryList:any=[];
  ItemMasterList:any=[];
  TotalAvailableQty:any;
  constructor(private bookstoreservice: BookstoreService, private lookupservice: LookupService,
    public globalHelper: GlobalHelper, private spinnerService: Ng4LoadingSpinnerService) { }

    InventoryModel = {
      ItemCategoryID: 0,
      InventoryCategoryID:2,
      ItemID: 0
  }

  GetTotal() {

    var TotalAvailableQty = 0;   
    for (var i = 0; i < this.StockInformationList.length; i++) {
        TotalAvailableQty = TotalAvailableQty + (this.StockInformationList[i].AvailableQty);       
    }
    this.TotalAvailableQty = TotalAvailableQty;
    
}
GetStockInformation() {
  this.spinnerService.show();
  this.bookstoreservice.GetStockInformation(JSON.stringify(this.InventoryModel)).subscribe((data: any) => {
    this.spinnerService.hide();
      this.StockInformationList = data.StockInformationList;
      this.globalHelper.CheckActionStatus(data);
      this.GetTotal();
      
  });
};


  ngOnInit() {
    this.GetItemCategory();
    this.GetAllItem();
  }

  GetItemCategory() {
    var item = {
        ItemId: 2
    }
    this.lookupservice.GetLookupsList('StockInventoryItemCategory', JSON.stringify(item)).subscribe((data: any) => {
        this.ItemCategoryList = data.LookupItems;
    });
};

GetAllItem() {
  this.spinnerService.show();
    var itemBo = {
        'ItemId': this.InventoryModel.ItemCategoryID,
        'ItemId1': 2,
    }
    this.lookupservice.GetLookupsList('ItemMaster', JSON.stringify(itemBo)).subscribe((data: any) => {
        this.ItemMasterList = data.LookupItems;
        this.spinnerService.hide();
    });
};

}
